export default __webpack_public_path__ + "static/media/T5-output2.e60d3668.png";